// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import fastClick from 'fastclick'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueWechatTitle from 'vue-wechat-title'

// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts


// 基础样式表
import './assets/styles/reset.css'
import './assets/styles/iconfont.css'
// 1像素边框
import './assets/styles/border.css'

Vue.config.productionTip = false
fastClick.attach(document.body)
Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(require('vue-wechat-title'))
// Vue.use(MintUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js